import { activeCurrencies } from "utils";

export const MAX_VOUCHER_ENTRIES = 50;
export const MAX_VOUCHER_QUANTITY = 100;
export const MAX_TOTAL_VOUCHERS = 100;

export const createVoucherEntry = (source) => ({
	key: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
	number_of_tokens: source?.number_of_tokens ?? "",
	expiry_date: source?.expiry_date ?? "",
	is_hlf: Boolean(source?.is_hlf),
	tag: source?.tag ?? "",
	currency: source?.currency ?? activeCurrencies.USD.code,
	quantity: 1,
});

export const totalVoucherCount = (entries = []) =>
	entries.reduce((sum, entry) => sum + (Number(entry.quantity) || 0), 0);

export const toVoucherPayload = (entries) =>
	entries.map(({ key, ...voucher }) => voucher);
